<script>
import axios from 'axios';
import Layout from '../layouts/main';
import PageHeader from '@/components/page-header';
import Swal from 'sweetalert2';
import { authFackMethods } from '@/state/helpers';

import { required, email } from 'vuelidate/lib/validators';

export default {
	page: {
		title: 'Users',
		meta: [
			{
				name: 'Users',
			},
		],
	},
	components: { Layout, PageHeader },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			users: {},
			userId: '',
			preservePage: 1,
			pageLimit: 50,
			modalTitle: '',
			types: null,
			locations: null,
			userForm: {
				first_name: '',
				last_name: '',
				email: '',
				password: '',
				user_type_id: null,
				location_id: null,
				user_location: null,
				status: null,
				UsserTypes: [],
			},
			typesubmit: false,
			isUpdate: false,
			isAdd: false,
			isLoading: false,
			noRecord: false,
			searchBy: {
				location_id: '',
				user_type_id: '',
				username: '',
			},
		};
	},
	validations: {
		userForm: {
			first_name: { required },
			last_name: { required },
			email: { required, email },
			user_type_id: { required },
			// location_id: { required },
			user_location: { required },
			// status: { required }
		},
	},
	mounted() {
		this.getUsers();
		this.getUserTypes();
		this.getLocations();
		// this.getBuildings();
	},
	methods: {
		...authFackMethods,

		getUsers(page) {
			this.isLoading = true;
			this.noRecord = false;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			let filter = '&per_page=' + this.pageLimit;
			if (this.searchBy.location_id != '') {
				filter += '&location_id=' + this.searchBy.location_id;
			}
			if (this.searchBy.user_type_id != '') {
				filter += '&user_type_id=' + this.searchBy.user_type_id;
			}
			if (this.searchBy.username != '') {
				filter += '&username=' + this.searchBy.username;
			}

			// include in-active users
			filter += '&is_active=0';

			axios
				.get('admin/users?pagination=true&page=' + page + filter)
				.then((res) => {
					this.users = res.data.response;
					console.log(this.users);
					this.isLoading = false;
					if (!this.users.data.length) {
						this.noRecord = true;
						if (page > 1) {
							this.getUsers(page - 1);
						}
					}
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},

		emptyUserFields() {
			this.userForm = {
				first_name: '',
				last_name: '',
				email: '',
				user_type_id: null,
				location_id: null,
				building_id: null,
				status: null,
				UsserTypes: [],
			};
		},

		showEditModal(user) {
			this.getUserTypes();
			this.getLocations();
			this.modalTitle = 'Edit User';
			this.$bvModal.show('userModal');
			this.userForm.first_name = user.first_name;
			this.userForm.last_name = user.last_name;
			this.userForm.email = user.email;
			this.userForm.user_type_id = user.user_type_id;
			this.userForm.location_id = user.location_id;
			this.userForm.user_location = user.locations;
			this.userForm.status = user.status;
			this.userForm.UserTypes = user.UserTypes && user.UserTypes.length ? user.UserTypes.map((x) => x.id) : [];
			this.userId = user.id;
			this.isUpdate = true;
			this.isAdd = false;
		},

		showAddModal() {
			this.getUserTypes();
			this.getLocations();
			this.modalTitle = 'Add User';
			this.$bvModal.show('userModal');
			this.isAdd = true;
			this.isUpdate = false;
			this.emptyUserFields();
		},

		getUserTypes() {
			axios.get('admin/user/types').then((res) => {
				this.types = res.data.response;
			});
		},

		getLocations() {
			axios.get('admin/locations').then((res) => {
				this.locations = res.data.response;
			});
		},

		getBuildings() {
			axios.get('admin/buildings').then((res) => {
				this.buildings = res.data.response;
			});
		},

		saveUser() {
			this.typesubmit = true;
			// stop here if form is invalid
			this.$v.$touch();
			if (!this.$v.$invalid) {
				var token = localStorage.getItem('token');
				var config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				if (token) {
					axios
						.post('admin/users', this.userForm, config)
						.then((res) => {
							if (res.status == '200') {
								Swal.fire({
									title: 'Success!',
									text: 'User added successfully!',
									icon: 'success',
									width: 350,
									showConfirmButton: false,
									timer: 1500,
								});
								this.getUsers();
								this.emptyUserFields();
								this.$bvModal.hide('userModal');
							}
						})
						.catch((err) => {
							if (err.response) {
								Swal.fire({
									title: 'Error!',
									text: err.response.data.error.message,
									icon: 'danger',
									width: 350,
									showConfirmButton: true,
								});
							}
						});
				}
			}
		},

		updateUser() {
			this.typesubmit = true;
			// stop here if form is invalid
			this.$v.$touch();
			if (!this.$v.$invalid) {
				var token = localStorage.getItem('token');
				var config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				if (token) {
					axios
						.post('admin/users/' + this.userId, this.userForm, config)
						.then((res) => {
							if (res.status == '200') {
								Swal.fire({
									title: 'Success!',
									text: 'User updated successfully!',
									icon: 'success',
									width: 350,
									showConfirmButton: false,
									timer: 1500,
								});
								this.getUsers();
								this.emptyUserFields();
								this.$bvModal.hide('userModal');
								this.typesubmit = false;
							}
						})
						.catch((err) => {
							if (err.response) {
								Swal.fire({
									title: 'Error!',
									text: err.response.data.error.message,
									icon: 'danger',
									width: 350,
									showConfirmButton: true,
								});
							}
						});
				}
			}
		},

		deleteUser(user, status) {
			console.log(user);
			Swal.fire({
				title: 'Are you sure?',
				// text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#34c38f',
				cancelButtonColor: '#f46a6a',
				showLoaderOnConfirm: true,
				confirmButtonText: 'Yes!',
			}).then((result) => {
				if (result.isConfirmed) {
					var token = localStorage.getItem('token');
					var config = {
						headers: {
							Authorization: 'Bearer ' + token,
							Accept: 'application/json',
						},
					};
					if (token) {
						let status_filter = '?status=' + status;
						axios
							.delete('admin/users/' + user.id + status_filter, config)
							.then((res) => {
								if (res.status == '200') {
									Swal.fire({
										title: 'Succcess!',
										// text: user.username + " has been deleted!",
										icon: 'success',
										width: 350,
										showConfirmButton: false,
										timer: 1500,
									});
									this.getUsers(this.preservePage);
								}
							})
							.catch((err) => {
								if (err.response) {
									Swal.fire({
										title: 'Error!',
										text: err.response.data.error.message,
										icon: 'danger',
										width: 350,
										showConfirmButton: true,
									});
								}
							});
					}
				}
			});
		},

		doSearch(page) {
			this.isLoading = true;
			this.noRecord = false;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			let filter = '&per_page=' + this.pageLimit;
			if (this.searchBy.location_id != '') {
				filter += '&location_id=' + this.searchBy.location_id;
			}
			if (this.searchBy.user_type_id != '') {
				filter += '&user_type_id=' + this.searchBy.user_type_id;
			}
			if (this.searchBy.username != '') {
				filter += '&username=' + this.searchBy.username;
			}
			axios
				.get('admin/users?pagination=true&page=' + page + filter)
				.then((res) => {
					this.users = res.data.response;
					this.isLoading = false;
					if (!this.users.data.length) {
						this.noRecord = true;
						if (page > 1) {
							this.getUsers(page - 1);
						}
					}
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

		<div class="card">
			<div class="card-body">
				<div class="d-flex">
					<div class="me-2">
						<h5 class="card-title mb-3">Users</h5>
					</div>

					<div class="mb-4 ms-auto">
						<b-button id="show-btn" @click="showAddModal" variant="primary" title="Add"> Add User </b-button>
					</div>
				</div>

				<form class="row align-items-center form-inline mb-4 border p-3 m-0">
					<div class="col-md-4">
						<input v-model="searchBy.username" type="text" class="ps-4 form-control" placeholder="Type User Name" />
					</div>
					<div class="col-md-3">
						<b-form-select class="form-select" v-model="searchBy.location_id" value-field="id" text-field="name" :options="locations">
							<option slot="first" value="">-- All Locations --</option>
						</b-form-select>
					</div>
					<div class="col-md-3">
						<b-form-select class="form-select" v-model="searchBy.user_type_id" value-field="id" text-field="type" :options="types">
							<option slot="first" value="">-- All User Types --</option>
						</b-form-select>
					</div>
					<div class="col-md-2" style="text-align: right">
						<b-button id="show-btn" @click="() => getUsers()" variant="primary" block title="Search">
							<i class="bx bx-search-alt-2"> Search</i>
						</b-button>
					</div>
					<!-- <div class="col-md-6 pull-right">
            <div class="row app-search pt-0 pb-0">

              <div class="col-md-12 d-flex">
                <input v-if="isName"
                       v-model="searchForm.username"
                       type="text"
                       class="ps-4 form-control"
                       placeholder="Type User Name"
                />
                <input v-if="isPsvCheck"
                       v-model="searchForm.psv_check"
                       type="text"
                       class="ps-4 form-control"
                       placeholder="Type Status"
                />
                <b-form-select v-if="isUserType" class="form-select" v-model="searchForm.user_type_id"
                               :options="userTypes">
                  <option slot="first" :value="null" disabled>Select User Type</option>
                </b-form-select>

                <b-button v-if="isSearching" class="btn-find" id="show-btn" @click="searchRegisteredUsers"
                          variant="primary" title="Search">
                  <i class="bx bx-search-alt-2"> Search</i>
                </b-button>

                

              </div>
            </div>
          </div> -->
				</form>

				<div class="table-responsive">
					<table class="table table-bordered table-hover table-striped table-sm align-middle table-nowrap mb-0">
						<thead class="table-light">
							<tr>
								<th scope="col">Name</th>
								<th scope="col">Email</th>
								<th scope="col">Locations</th>
								<th scope="col">Permissions</th>
								<th scope="col">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-if="noRecord">
								<td colspan="6" class="p-0">
									<p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
								</td>
							</tr>
							<tr v-if="isLoading">
								<td colspan="6" class="text-center p-0">
									<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
								</td>
							</tr>

							<tr v-else v-for="(user, index) in users.data" :key="index">
								<td>
									<h5 class="font-size-13 text-truncate mb-1">
										{{ user.username }}
									</h5>
								</td>
								<td>
									<h5 class="font-size-13 text-truncate mb-1">
										{{ user.email }}
									</h5>
								</td>
								<td>
									<h5 class="font-size-13 text-muted mb-0 text-wrap">
										<p v-for="(location, i) in user.user_locations" :key="i">{{ location.name }}</p>
									</h5>
								</td>
								<td>
									<p class="text-muted mb-0 text-wrap">
										<span><strong>Primary:</strong> {{ user.UserType }}</span>
										<span v-if="user.UserTypes && user.UserTypes.length > 0">
											<br /><strong>Secondary: </strong>
											<span v-for="(userType, index) in user.UserTypes" :key="index">{{ `${userType.type}${user.UserTypes[index + 1] ? ', ' : ''}` }}</span>
										</span>
									</p>
								</td>
								<td>
									<b-button id="show-btn" @click="showEditModal(user)" variant="primary" title="Edit">
										<i class="bx bx-pencil"></i>
									</b-button>
									<b-button v-if="user.status != 0" @click="deleteUser(user, 0)" class="ms-2" variant="danger" title="DeActivate">
										<i class="bx bx-trash"></i>
									</b-button>
									<b-button v-if="user.status == 0" @click="deleteUser(user, 2)" class="ms-2" variant="success" title="activate">
										<i class="bx bx-check"></i>
									</b-button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<pagination class="mt-4" :data="users" :limit="10" @pagination-change-page="getUsers"></pagination>
			</div>
		</div>

		<b-modal id="userModal" centered :title="modalTitle" title-class="font-18" hide-footer>
			<form>
				<div class="row">
					<div class="col-6">
						<div class="mb-3">
							<label>First Name</label>
							<input
								v-model="userForm.first_name"
								type="text"
								class="form-control"
								placeholder="Enter First Name"
								name="first_name"
								:class="{
									'is-invalid': typesubmit && $v.userForm.first_name.$error,
								}"
							/>
							<div v-if="typesubmit && $v.userForm.first_name.$error" class="invalid-feedback">
								<span v-if="!$v.userForm.first_name.required">First name is required.</span>
							</div>
						</div>
					</div>

					<div class="col-6">
						<div class="mb-3">
							<label>Last Name</label>
							<input
								v-model="userForm.last_name"
								type="text"
								class="form-control"
								placeholder="Enter Last Name"
								name="last_name"
								:class="{
									'is-invalid': typesubmit && $v.userForm.last_name.$error,
								}"
							/>
							<div v-if="typesubmit && $v.userForm.last_name.$error" class="invalid-feedback">
								<span v-if="!$v.userForm.last_name.required">Last name is required.</span>
							</div>
						</div>
					</div>
				</div>

				<div class="mb-3">
					<label>Email</label>
					<input
						v-model="userForm.email"
						type="text"
						class="form-control"
						placeholder="Enter Email"
						name="email"
						:class="{
							'is-invalid': typesubmit && $v.userForm.email.$error,
						}"
					/>
					<div v-if="typesubmit && $v.userForm.email.$error" class="invalid-feedback">
						<span v-if="!$v.userForm.email.required">Email is required.</span>

						<span v-if="!$v.userForm.email.email">Invalid email.</span>
					</div>
				</div>

				<div class="mb-3">
					<label>Password</label>
					<input v-model="userForm.password" type="password" class="form-control" placeholder="******" name="password" />
					<span class="text-muted">leave blank if you don't want to {{ isUpdate ? 'updated' : 'add' }}</span>
				</div>

				<div class="mb-3">
					<label class="mt-0">Select Type</label>

					<b-form-select class="form-select" v-model="userForm.user_type_id" :options="types" value-field="id" text-field="type" :class="{ 'is-invalid': typesubmit && $v.userForm.user_type_id.$error }">
						<option slot="first" :value="null" disabled>Select User Type</option>
					</b-form-select>

					<div v-if="typesubmit && $v.userForm.user_type_id.$error" class="invalid-feedback">
						<span v-if="!$v.userForm.user_type_id.required">User Type is required.</span>
					</div>
				</div>

				<div class="mb-3">
					<label class="mt-0">Select Secondary types</label>
					<b-form-select multiple class="form-select" v-model="userForm.UserTypes" :options="types" value-field="id" text-field="type">
						<option slot="first" :value="null" disabled>Select Types</option>
					</b-form-select>
				</div>

				<div class="mb-3">
					<label class="mt-0">Select Locations</label>

					<b-form-select multiple class="form-select" v-model="userForm.user_location" :options="locations" value-field="id" text-field="name" :class="{ 'is-invalid': typesubmit && $v.userForm.user_location.$error }">
						<option slot="first" :value="null" disabled>Select Locations</option>
					</b-form-select>

					<div v-if="typesubmit && $v.userForm.user_location.$error" class="invalid-feedback">
						<span v-if="!$v.userForm.user_location.required">Location is required.</span>
					</div>
				</div>

				<!-- <div class="mb-3">
          <label class="mt-0">Select Building</label>
          <b-form-select class="form-select" v-model="userForm.building_id" :options="locations[userForm.building_id].buildings"
                         value-field="id"
                         text-field="name"
                         :class="{'is-invalid': typesubmit && $v.userForm.building_id.$error,}">
            <option slot="first" :value="null" disabled>Select Building</option>
          </b-form-select>
          <div v-if="typesubmit && $v.userForm.user_type_id.$error" class="invalid-feedback">
                  <span v-if="!$v.userForm.user_type_id.required"
                  >Building is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label class="mt-0">Select Status</label>
          <b-form-select class="form-select" v-model="userForm.status" :options="userStatus"
                         value-field="id"
                         text-field="label"
                         :class="{'is-invalid': typesubmit && $v.userForm.status.$error,}">
            <option slot="first" :value="null" disabled>Select Status</option>
          </b-form-select>
          <div v-if="typesubmit && $v.userForm.user_type_id.$error" class="invalid-feedback">
                  <span v-if="!$v.userForm.user_type_id.required"
                  >Status is required.</span>
          </div>
        </div> -->

				<div class="mb-0">
					<div>
						<div>
							<button type="button" v-if="isAdd" @click="saveUser" class="btn btn-primary">Add User</button>
							<button type="button" v-if="isUpdate" @click="updateUser" class="btn btn-primary">Update User</button>
						</div>
					</div>
				</div>
			</form>
		</b-modal>
	</Layout>
</template>
